import { HttpClient } from '@angular/common/http';
import { makeStateKey, StateKey, TransferState } from '@angular/core';
import merge from 'lodash/merge';

import { TranslateLoader } from '@ngx-translate/core';
import { Observable, combineLatest, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { LocationManagerService } from '@cakeiteasy/web-utils';
import { DOMAIN_LANGUAGE_CODE_MAP } from '../../translates/translates.service';

export class TranslatesBrowserLoaderService implements TranslateLoader {
  constructor(private prefix = 'i18n',
              private countriesDir = 'countries',
              private referencesDir = 'references',
              private marketplaceDir = 'marketplace',
              private suffix = '.json',
              private transferState: TransferState,
              private http: HttpClient,
              private locationManager: LocationManagerService) {
  }

  public getTranslation(lang: string): Observable<any> {
    const key: StateKey<number> = makeStateKey<number>(`transfer-translate-${lang}`);
    const data: any = this.transferState.get(key, null);
    const domainLang = DOMAIN_LANGUAGE_CODE_MAP[this.locationManager.getDomainName()];
    if (data) {
      return of(data);
    } else {
      return combineLatest([
        this.http.get(`${this.prefix}${lang}${this.suffix}`),
        this.http.get(`${this.prefix}${this.marketplaceDir}${lang}${this.suffix}`),
        this.http.get(`${this.prefix}${this.countriesDir}${lang}${this.suffix}`),
        this.http.get(`${this.prefix}${this.referencesDir}${domainLang}${this.suffix}`)
      ]).pipe(
        map(([commonTranslates, marketplaceTranslates, countryTranslates, referenceTranslates]) => {
          return merge(
            commonTranslates,
            { common: { countries: countryTranslates } },
            marketplaceTranslates,
            { references: referenceTranslates }
          );
        })
      );
    }
  }
}
